export const mockMarketPerformanceData = {
  highAds: 50,
  lowAds: 40,
  normalAds: 5,
  noRatingAds: 5,
  totalAds: 100,
};
